import t from "./index21.js";
import { openBlock as i, createElementBlock as r, createElementVNode as n } from "vue";
import "./index22.js";
import l from "../../../../_virtual/index.js";
const s = { class: "social-links" };
function p(a, e, f, v, k, c) {
  return i(), r("div", s, [
    n("a", {
      href: "https://facebook.com/LawDepotOfficial",
      "aria-label": "LawDepot Official Facebook",
      class: "social-links-facebook",
      target: "_blank",
      rel: "noopener",
      onClick: e[0] || (e[0] = (...o) => a.navigationEventBus.navigateToHref && a.navigationEventBus.navigateToHref(...o))
    }),
    n("a", {
      href: "https://twitter.com/LawDepot",
      "aria-label": "LawDepot Twitter",
      class: "social-links-twitter",
      target: "_blank",
      rel: "noopener",
      onClick: e[1] || (e[1] = (...o) => a.navigationEventBus.navigateToHref && a.navigationEventBus.navigateToHref(...o))
    }),
    n("a", {
      href: "http://linkedin.com/company/lawdepot",
      "aria-label": "LawDepot LinkedIn",
      class: "social-links-linkedin",
      target: "_blank",
      rel: "noopener",
      onClick: e[2] || (e[2] = (...o) => a.navigationEventBus.navigateToHref && a.navigationEventBus.navigateToHref(...o))
    })
  ]);
}
const b = /* @__PURE__ */ l(t, [["render", p], ["__scopeId", "data-v-121fcea8"]]);
export {
  b as default
};
//# sourceMappingURL=index7.js.map
